import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { OPEN_COMPANY_MODAL } from "../../constants/tables";
import { showModal } from "../../actions/modalActions";
import {
  acceptCompany,
  rejectCompany,
  submitCompany,
} from "../../actions/introActions";
import { TextArea } from "./../Modals/modal.styles";
import { Button } from "../../styles/button";
import styled from "styled-components";

import {
  CompanyName,
  AcceptBadge,
  IntrodBadge,
  NewBadge,
  PassBadge,
  Space,
} from "./GridItem.styles";
import {
  INTRODUCED,
  CANDIDATE_INTERESTED,
  CANDIDATE_NOT_INTERESTED,
  CONFIRMING_CANDIDATE_INTEREST,
} from "../../constants/introPriorities";
import ReactGA from "react-ga";
import "./grid-style.css";

const ModalButton = styled(Button)`
  border-color: #283678;
  border-radius: 4px;
  height: 40px;
  width: 80px;
  display: inline-block;
  font-size: 10px;
  color: #0b233f;
`;
const InterestedButton = styled(ModalButton)`
  background-color: #bbdfe4;
`;
const PassButton = styled(ModalButton)`
  background-color: #ff8f80;
`;

class GridItem extends React.Component {
  constructor(props) {
    super(props);

    const { company, intros } = props;
    this.state = {
      company,
      intro: intros.find(
        (intro) => intro.destination_organization_id === company.id
      ),
      interest_blurb: "",
    };

    this.toggleWhyInterestedBlock = this.toggleWhyInterestedBlock.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.handleAccept = this.handleAccept.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.handleInterestChange = this.handleInterestChange.bind(this);
    this.submitInterest = this.submitInterest.bind(this);
  }

  displayBadge = () => {
    const { intro } = this.state;
    switch (intro.other_data.member_status) {
      case "ACCEPTED":
        return <AcceptBadge>Accepted</AcceptBadge>;
      case "PASSED":
        return <PassBadge>Passed</PassBadge>;
      case "INTRODUCED":
        return <IntrodBadge>Introduced</IntrodBadge>;
      default:
        return <NewBadge>New</NewBadge>;
    }
  };

  renderCompanyLogo(logoLink) {
    if (logoLink) {
      return <img alt="" height="auto" width="100" src={logoLink}></img>;
    } else {
      return <Space />;
    }
  }

  toggleWhyInterestedBlock(status, hide) {
    if (hide) {
      let ele = document.getElementById(
        `company-card-${this.state.company.id}`
      );
      if (ele) ele.classList.remove("slideMoreInfo", "accepted", "rejected");
      return;
    }
    const { company } = this.state;
    let whyQuestion,
      placeholder = "";
    if (status === "rejected") {
      whyQuestion = `Knowing why you are passing on <span style="font-size:18px;color:black">${company.name}</span> helps us make sure we share the most relevant companies with you.
      <br/> We do not share this with companies.`;
      placeholder = `e.g. It looks like an exciting opportunity, but not in my area of expertise...`;
    } else {
      whyQuestion = `<span style="font-size:18px;color:black">${company.name}</span> would appreciate it if you mention why you are interested in them.<br/>
    We highly recommend adding a short blurb on why you are interested!`;
      placeholder = `e.g. I've seen XYZ consistently listed as one of the top places to work....`;
    }

    let currCompanyEle = document.getElementById(
      `company-card-${this.state.company.id}`
    );
    currCompanyEle.querySelector("#ask-why").innerHTML = whyQuestion;
    currCompanyEle.querySelector(".why-input").placeholder = placeholder;
    currCompanyEle.classList.add("slideMoreInfo", status);
  }

  handleAccept(event) {
    event.stopPropagation();
    event.preventDefault();
    ReactGA.event({
      category: "CANDIDATE_ACTION",
      action: "ACCEPTED",
      label: "COMPANY_CARD",
    });

    this.toggleWhyInterestedBlock("accepted", false);
    this.props.acceptCompany({
      intro_id: this.state.intro.id,
      interest_blurb: "",
      interest_role: null,
      place: "from_grid",
    });
  }

  handleReject(event) {
    event.stopPropagation();
    event.preventDefault();
    ReactGA.event({
      category: "CANDIDATE_ACTION",
      action: "REJECTED",
      label: "COMPANY_CARD",
    });
    this.toggleWhyInterestedBlock("rejected");
    this.props.rejectCompany({
      intro_id: this.state.intro.id,
      interest_blurb: "",
      place: "from_grid",
    });
  }

  submitInterest() {
    this.toggleWhyInterestedBlock(undefined, true);
    ReactGA.event({
      category: "CANDIDATE_ACTION",
      action: "INTEREST_ADDED",
      label: "COMPANY_CARD",
    });
    this.props.submitCompany({
      intro_id: this.state.intro.id,
      interest_blurb: this.state.interest_blurb,
      interest_role: null,
      place: "from_grid",
    });
  }

  handleInterestChange(event) {
    this.setState({ interest_blurb: event.target.value });
  }

  renderButton() {
    switch (this.state.intro.other_data.member_status) {
      case INTRODUCED:
        return (
          <div className="outer-container">
            <InterestedButton onClick={this.showCompanyModal}>
              View
            </InterestedButton>
            <PassButton disabled onClick={this.handleReject}>
              Pass
            </PassButton>
          </div>
        );
      case CANDIDATE_INTERESTED:
        return (
          <div className="outer-container">
            <InterestedButton onClick={this.showCompanyModal}>
              View
            </InterestedButton>
            <PassButton disabled onClick={this.handleReject}>
              Pass
            </PassButton>
          </div>
        );
      case CANDIDATE_NOT_INTERESTED:
        return (
          <div className="outer-container">
            <InterestedButton onClick={this.showCompanyModal}>
              View
            </InterestedButton>
            <PassButton disabled onClick={this.handleReject}>
              Pass
            </PassButton>
          </div>
        );
      case CONFIRMING_CANDIDATE_INTEREST:
        return (
          <div className="outer-container">
            <InterestedButton onClick={this.showCompanyModal}>
              View
            </InterestedButton>
            <PassButton onClick={this.handleReject}>Pass</PassButton>
          </div>
        );
      default:
        return (
          <div className="outer-container">
            <InterestedButton disabled onClick={this.showCompanyModal}>
              View
            </InterestedButton>
            <PassButton disabled onClick={this.handleReject}>
              Pass
            </PassButton>
          </div>
        );
    }
  }

  showCompanyModal = () => {
    const { company, intro } = this.state;
    const companyId = company.id;

    this.props.showModal(OPEN_COMPANY_MODAL, {
      id: companyId,
      new_comp: company,
      new_intro: intro,
    });
  };

  render() {
    const { company } = this.state;
    const companyId = company.id;

    return (
      <div className="company-box" id={`company-card-${companyId}`}>
        <div
          className="card-main"
          key={company.name}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <div
            onClick={this.showCompanyModal}
            style={{
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-around",
              alignItems: "center",
              margin: "20px 0",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <CompanyName>{company.name}</CompanyName>
              {this.displayBadge()}
            </div>
            {this.renderCompanyLogo(company.logo_link)}
          </div>
          {this.renderButton()}
        </div>
        <div className="informations-container">
          <div className="more-information">
            <h2 className="statement" id="ask-why">
              Understanding Why
            </h2>
            <TextArea
              className="why-input statement"
              value={this.state.interest_blurb || ""}
              style={{
                padding: 10,
                paddingBottom: 0,
                fontSize: "14px",
                marginBottom: "unset",
              }}
              rows="6"
              onChange={this.handleInterestChange}
            ></TextArea>
            <div className="accept-company">
              <span
                onClick={() => {
                  ReactGA.event({
                    category: "CANDIDATE_ACTION",
                    action: "INTEREST_SKIPPED",
                    label: "COMPANY_CARD",
                  });
                  this.toggleWhyInterestedBlock(undefined, true);
                }}
                className="link"
              >
                Skip
              </span>
              <ModalButton
                style={{ backgroundColor: "#1ca902", color: "white" }}
                onClick={this.submitInterest}
              >
                Submit
              </ModalButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showModal,
      acceptCompany,
      rejectCompany,
      submitCompany,
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(GridItem);



// WEBPACK FOOTER //
// ./src/components/Grid/GridItem.js